/* Whys Books · v8 behaviours: rolling countdown, welcome popup, proof toasts */
(function () {
  'use strict';

  /* ---------- Countdown: a fixed-length window that rolls over on a global clock ----------
     The deadline is the next multiple of `days` since the Unix epoch (UTC), so every visitor
     sees the same time left and it resets automatically without anyone touching the store. */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function countdowns() {
    var els = document.querySelectorAll('[data-wb-countdown]');
    if (!els.length) return;
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var days = parseFloat(el.getAttribute('data-days')) || 3;
        var period = days * 86400000;
        var end = Math.ceil(now / period) * period;
        if (end - now < 1000) end += period;
        var left = end - now;
        var d = Math.floor(left / 86400000);
        var h = Math.floor((left % 86400000) / 3600000);
        var m = Math.floor((left % 3600000) / 60000);
        var s = Math.floor((left % 60000) / 1000);
        var dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'), mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
        if (dd) { dd.textContent = d; dd.parentNode.hidden = d === 0; }
        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Welcome popup ---------- */
  function popup() {
    var el = document.querySelector('[data-wb-popup]');
    if (!el) return;
    var KEY = 'wb_popup_seen', DAYS = 7;
    var success = el.classList.contains('is-success');
    var seen = null;
    try { seen = localStorage.getItem(KEY); } catch (e) {}
    var fresh = seen && (Date.now() - parseInt(seen, 10)) < DAYS * 86400000;
    if (fresh && !success) return;

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      el.hidden = false;
      setTimeout(function () { el.classList.add('is-open'); }, 30);
      document.documentElement.classList.add('wb-popup-lock');
      var first = el.querySelector('input[type=email]') || el.querySelector('[data-wb-popup-close]');
      if (first) setTimeout(function () { first.focus(); }, 250);
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    function close() {
      el.classList.remove('is-open');
      document.documentElement.classList.remove('wb-popup-lock');
      setTimeout(function () { el.hidden = true; }, 250);
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    el.querySelectorAll('[data-wb-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    el.addEventListener('click', function (e) { if (e.target === el) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });

    var copy = el.querySelector('[data-wb-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = copy.getAttribute('data-wb-copy');
      var done = function () { copy.textContent = 'Copied'; copy.classList.add('is-done'); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });

    if (success) { open(); return; }
    var timer = setTimeout(open, 6000);
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max > 0.25) { clearTimeout(timer); open(); window.removeEventListener('scroll', onScroll); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.querySelectorAll('[data-wb-popup-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); opened = false; open(); }); });
  }

  /* ---------- Proof toasts: real reviews, and real orders when the shop publishes them ---------- */
  function toasts() {
    var host = document.querySelector('[data-wb-toasts]');
    if (!host) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = [];
    try { items = JSON.parse(host.querySelector('script[type="application/json"]').textContent) || []; } catch (e) {}
    if (!items.length) return;
    var KEY = 'wb_toast_off';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var i = Math.floor(Math.random() * items.length), showing = null;
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function stars(n) { var out = ''; for (var k = 0; k < 5; k++) out += '<i class="' + (k < n ? 'is-on' : '') + '"></i>'; return '<span class="wb-toast__stars" aria-label="' + n + ' out of 5 stars">' + out + '</span>'; }
    function render(it) {
      var html;
      if (it.type === 'order') {
        html = '<span class="wb-toast__pic">' + (it.img ? '<img src="' + it.img + '" alt="" width="44" height="60" loading="lazy">' : '') + '</span>' +
          '<span class="wb-toast__body"><b>' + esc(it.title) + '</b><span>' + esc(it.text) + '</span><small>' + esc(it.meta || '') + '</small></span>';
      } else {
        html = '<span class="wb-toast__body">' + stars(it.stars || 5) + '<span>“' + esc(it.text) + '”</span><small>' + esc(it.meta || 'Verified buyer') + '</small></span>';
      }
      var t = document.createElement('div');
      t.className = 'wb-toast wb-toast--' + (it.type || 'review');
      t.setAttribute('role', 'status');
      t.innerHTML = html + '<button type="button" class="wb-toast__x" aria-label="Hide">&times;</button>';
      t.querySelector('.wb-toast__x').addEventListener('click', function () { hide(t); try { sessionStorage.setItem(KEY, '1'); } catch (e) {} clearTimeout(loop); });
      return t;
    }
    function hide(t) { t.classList.remove('is-in'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 400); }
    var loop;
    function next() {
      if (showing) hide(showing);
      var it = items[i % items.length]; i++;
      var t = render(it);
      host.appendChild(t);
      setTimeout(function () { t.classList.add('is-in'); }, 30);
      showing = t;
      loop = setTimeout(function () { hide(t); showing = null; loop = setTimeout(next, 14000); }, 7000);
    }
    loop = setTimeout(next, 12000);
  }

  function init() { countdowns(); popup(); toasts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
